<template>
    <v-card elevation="0" class="border-radius-1 px-4 px-md-5">
    <template data-cy="carousel-box" class="carousel-box">
        <v-row class="flex-nowrap position-relative" align="center" justify="space-between">
            <v-row
                v-if="this.$route.name === 'home'"
                class="header-section w-100 position-relative">
                <v-col cols="2" class="align-items-center d-none d-sm-block">
                    <v-img
                        :src="require('@/assets/img/icons/challenge-detail/recommendations.png')"
                        height="120"
                        width="145"
                        class="img-titles-absolute">
                    </v-img>
                </v-col>
                <v-col>
                    <h3>{{ titleCarousel }}</h3>
                    <p>{{ subTitleCarousel }}</p>
                </v-col>
            </v-row>

            <v-col cols="" class="flex-fill text-start" v-if="this.$route.name !== 'home'">
                <h2 class="title-carousel">{{ titleCarousel }}</h2>
                <h3 class="subtitle-carousel d-none d-sm-block">{{ subTitleCarousel }}</h3>
            </v-col>
            <v-col class="ml-auto d-none d-sm-block py-0">
                <v-row class=" flex-nowrap">
                    <!-- <v-col cols="auto" v-if="!mostPopular && listOfBooksAvailable === 1">
                        <v-btn
                            color="primary"
                            outlined
                            class="text-transform-none border-radius-1"
                        >
                        {{ $t('library.more') }}
                        </v-btn>
                    </v-col> -->
                    <v-col cols="auto" class="">
                        <template v-if="listOfBooksAvailable === 1">
                            <v-btn outlined color="#323A46" @click="showLeft" :disabled="disableLeft" icon>
                                <v-icon>
                                    mdi-chevron-left
                                </v-icon>
                            </v-btn>
                        </template>
                    </v-col>
                    <v-col cols="auto" class="pl-0">
                        <template v-if="listOfBooksAvailable === 1">
                            <v-btn icon outlined color="#323A46" :disabled="disableRigth" @click="showRight">
                                <v-icon color="#323A46">
                                    mdi-chevron-right
                                </v-icon>
                            </v-btn>
                        </template>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-col cols="12" class="text-left px-0">
            <div
                v-if="listOfBooksAvailable === 1"
                class="position-relative"
            >
                <VueSlickCarousel v-bind="settings" ref="carousel" @beforeChange="before">
                    <div :class="`${classCard}`" v-for="(item, i) in booksList.data" :key="i">
                        <book-card-pop-up
                            @cardPopUp="cardPopUp = $event"
                            :title="item.title"
                            :rating="item.rating"
                            :description="item.bookAbstract"
                            :imageSource="item.resourceDir"
                            :book_id="item.id"
                            :book="item"
                            :topNumber="i + 1"
                            :mostPopular="mostPopular"
                        />
                    </div>
                </VueSlickCarousel>
            </div>
            <v-row class="d-flex flex-row justify-center" v-if="listOfBooksAvailable === 0">
                <v-col cols="2" v-for="(n, index) in 6" :key="index">
                    <v-skeleton-loader height="300px" width="100%" type="image" />
                </v-col>
            </v-row>

            <v-card height="200px" width="100%" elevation="0" v-if="listOfBooksAvailable > 1 && this.$route.name != 'books'">
                <v-overlay absolute value="true" opacity="1" color="#F7F8F9" class="error-contain">
                    <v-row
                        class="ma-0 pa-12 text-h6 text--neutral text-md-h5 font-weight-regular"
                        justify="center"
                        align="center"
                        >
                        {{ textDisabled }}
                    </v-row>
                </v-overlay>
            </v-card>
            <v-card height="200px" width="100%" elevation="0" v-if="listOfBooksAvailable > 1 && this.$route.name === 'books'">
                <v-overlay absolute value="true" opacity="1" color="#F7F8F9">
                    <v-row
                        class="ma-0 text--neutral text-center"
                        justify="center"
                        align="center"
                        v-if="titleCarousel == 'Mi lista'"
                        >
                        <v-col cols="12">
                            <v-btn
                            fab
                            dark
                            color="#B8C0CC"
                            elevation="1"
                            to="/user/library"
                            >
                                <v-icon dark>
                                    mdi-plus
                                </v-icon>
                            </v-btn>
                        </v-col>
                        <v-col cols="12" class="py-0">
                            <p class="mb-0 text-h6">{{ $t('library.add_a_book') }}</p>
                        </v-col>
                        <v-col cols="12" class="py-0">
                            <p class="mb-0">{{ $t('library.choose_a_book_from_the_library') }}</p>
                        </v-col>
                    </v-row>
                    <v-row
                        class="ma-0 text--neutral text-center"
                        justify="center"
                        align="center"
                        v-if="titleCarousel == 'Mis libros comprados'"
                        >
                        <v-col cols="12">
                            <v-btn
                            fab
                            dark
                            color="#B8C0CC"
                            elevation="1"
                            to="/user/store"
                            >
                                <v-icon dark>
                                    mdi-plus
                                </v-icon>
                            </v-btn>
                        </v-col>
                        <v-col cols="12" class="py-0">
                            <p class="mb-0 text-h6">{{ $t('library.buy_a_book') }}</p>
                        </v-col>
                        <v-col cols="12" class="py-0">
                            <p class="mb-0">{{ $t('library.collect_beecoins') }}</p>
                        </v-col>
                    </v-row>
                </v-overlay>
            </v-card>
        </v-col>
    </template>
</v-card>
</template>
<script>
import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
// optional style for arrows & dots
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import BookCardPopUpVue from './BookCardPopUp.vue'

export default {
    name: 'BookCarouselPopUp',
    components: {
        'book-card-pop-up': BookCardPopUpVue,
        VueSlickCarousel
    },
    data() {
        return {
            settings: {
                infinite: false,
                arrows: false,
                slidesToScroll: 3,
                variableWidth: true,
                speed: 500,
                rows: 1,
            },
            disableLeft: true,
            disableRigth: false,
        }
    },
    props: ['titleCarousel', 'subTitleCarousel', 'booksList', 'mostPopular'],
    computed: {
        classCard() {
            if (this.cardPopUp) {
                return 'pop-up-enabled'
            }
            return 'pop-up-disabled'
        },
        listOfBooksAvailable() {
            return this.booksList.code
        },
        textDisabled() {
            if (this.booksList.code === 2) {
                return this.$t('library.no_books_found')
            }
            return this.$t('library.error_consulting_books')
        }
    },
    methods: {
        showRight() {
            this.$refs.carousel.next()
        },
        showLeft() {
            this.$refs.carousel.prev()
        },
        before(oldSlideIndex, newSlideIndex) {
            const breakItems = this.disableArrowsByItems();
            if (newSlideIndex === this.booksList.data.length - breakItems) {
                this.disableRigth = true;
                this.disableLeft = false;
            } else if (newSlideIndex > 0) {
                this.disableRigth = false;
                this.disableLeft = false;
            } else {
                this.disableRigth = false;
                this.disableLeft = true;
            }
        },
        disableArrowsByItems() {
            switch (this.$vuetify.breakpoint.name) {
                case 'md':
                    return 2;
                case 'lg':
                    return 1;
                case 'xl':
                    return 1;
                default :
                    return 1;

            }
        },
    }
}
</script>
<style lang="scss">
.title-carousel{
    font-size: 1.25rem;
    font-weight: 700;
    line-height: 100%;
}
.subtitle-carousel{
    color: #64748B;
    font-size: 1rem;
    font-weight: 400;
}
.gradient-background {
    width: 20%;
    position: absolute;
    bottom: 0;
    height: 85%;
}
.gradient-background-carrousel-right {
    right: 0;
    background: linear-gradient(90deg, rgba(255, 255, 255, 0) 70%, rgba(255, 255, 255, 1) 100%);
}

.gradient-background-carrousel-left {
    left: 0;
    background: linear-gradient(90deg, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 30%);
}

.pop-up-disabled, .pop-up-enabled {
    outline: 0;
}
.text--neutral{
    color: #64748B;
}
.error-contain{
    text-align: center;
    .v-overlay__scrim{
        background: #F7F8F9!important;
    }
}
</style>
